module.exports = __webpack_public_path__ + "static/media/vt_em.f5572c49.pdf";